export const heroSlides = [
  {
    id: 'h1',
    title: '年度音乐盛典落幕，新生代歌手包揽五项大奖',
    excerpt: '当晚舞台高潮迭起，新生代歌手用稳定的现场表现拿下重磅奖项，多个片段迅速登上热搜。',
    image: 'https://readdy.ai/api/search-image?query=Grand%20music%20awards%20stage%20with%20warm%20orange%20and%20gold%20spotlights%2C%20glowing%20confetti%2C%20cinematic%20editorial%20photography%2C%20dramatic%20atmosphere%2C%20clean%20premium%20background&width=1600&height=900&seq=home-hero-01&orientation=landscape',
    linkId: 'n1',
    tag: '焦点推荐',
  },
  {
    id: 'h2',
    title: '悬疑剧《雾城谜影》口碑走高，连续三周登顶热度榜',
    excerpt: '克制的叙事与扎实的表演让这部都市悬疑剧持续走红，观众直呼“每集都有新猜想”。',
    image: 'https://readdy.ai/api/search-image?query=Moody%20foggy%20urban%20night%20cityscape%20with%20warm%20streetlight%20glow%20and%20neon%20reflections%2C%20cinematic%20editorial%20photography%2C%20dramatic%20atmosphere%2C%20clean%20modern%20background&width=1600&height=900&seq=home-hero-02&orientation=landscape',
    linkId: 'n2',
    tag: '影视热播',
  },
  {
    id: 'h3',
    title: '综艺《星厨来客》开播即爆，素人厨艺对决成新看点',
    excerpt: '把镜头交给普通人的厨房，用真实的烟火气打动观众，首期播放量刷新频道纪录。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20kitchen%20with%20golden%20light%20and%20steaming%20homestyle%20dishes%2C%20editorial%20lifestyle%20photography%2C%20warm%20inviting%20atmosphere%2C%20clean%20background&width=1600&height=900&seq=home-hero-03&orientation=landscape',
    linkId: 'n3',
    tag: '热门综艺',
  },
  {
    id: 'h4',
    title: '古装大制作《长安夜行》公布首支预告，质感获赞',
    excerpt: '两分钟先导预告用光影勾勒繁华古都，实景搭建与手工服装细节被网友称为“高完成度制作”。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20city%20at%20night%20with%20warm%20lantern%20glow%20and%20palace%20architecture%2C%20cinematic%20epic%20photography%2C%20rich%20warm%20tones%2C%20clean%20premium%20background&width=1600&height=900&seq=home-hero-04&orientation=landscape',
    linkId: 'n4',
    tag: '重磅预告',
  },
];